import React from 'react';
import { useQuote } from '../../contexts/QuoteContext';
import type { DeliveryLocation } from '../../types/quote';
import productConfig from '../../data/productConfig.json';

interface Step6DeliveryLocationProps {
  isActive: boolean;
  isCompleted: boolean;
  isDisabled: boolean;
}

// Get delivery locations from productConfig
const deliveryLocations: DeliveryLocation[] = productConfig.deliveryLocations as DeliveryLocation[];

const Step6DeliveryLocation: React.FC<Step6DeliveryLocationProps> = ({ isActive, isCompleted, isDisabled }) => {
  const { quoteState, updateQuoteState } = useQuote();

  const handleLocationSelect = (location: DeliveryLocation) => {
    if (isDisabled) return;
    updateQuoteState({ selectedDeliveryLocation: location });
  };

  return (
    <div className={`step-section ${isActive ? 'active' : isDisabled ? 'disabled' : 'inactive'} ${!isActive && !isCompleted ? 'collapsed' : ''}`}>
      <div className="step-header">
        <div className={`step-number ${isCompleted ? 'completed' : isActive ? 'active' : 'disabled'}`}>
          <span>6</span>
        </div>
        <h2 className="step-title">Set Delivery Location</h2>
      </div>
      <p style={{
          backgroundColor: '#fff3cd',
          fontFamily: 'Syne',
          border: '2px solid #ffc107',
          padding: '10px',
          margin: '10px 0',
          fontStyle: 'italic'
        }}
      >
        Delivery price is displayed for testing purposes.
      </p>
      {(isActive || isCompleted) && (
        <div className="location-options">
          {deliveryLocations.map((location) => (
            <div
              key={location.id}
              className={`location-card ${quoteState.selectedDeliveryLocation?.id === location.id ? 'selected' : ''} ${isDisabled ? 'disabled' : ''}`}
              onClick={() => handleLocationSelect(location)}
              style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
            >
              <div className="location-content">
                <h3 className="location-name">{location.name}</h3>
                <p className="location-address">{location.address}</p>
                <div className="location-fee">
                  {location.deliveryFee === "POA"
                    ? "POA"
                    : typeof location.deliveryFee === 'number' && location.deliveryFee > 0
                      ? `$${location.deliveryFee.toLocaleString()} delivery`
                      : 'Free delivery'}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Step6DeliveryLocation;
